import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=ebd6267c&"
import script from "./UserPanel.vue?vue&type=script&lang=js&"
export * from "./UserPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=ebd6267c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports